import { Navigate } from 'react-router-dom';

const IntegrationList = async () =>
    import('../../pages/integrations/List').then((module) => ({ Component: module.IntegrationsList }));

export const getIntegrationsRoutes = () => {
    return [
        {
            path: '/logistic-management/integrations/',
            element: <Navigate to='/logistic-management/integrations/jobs/' />,
            redirectFrom: ['/logistic-management/integrations'],
        },
        {
            path: '/logistic-management/integrations/jobs/',
            lazy: IntegrationList,
        },
        {
            path: '/logistic-management/integrations/jobs/view/:viewId',
            lazy: IntegrationList,
        },
        {
            path: '/logistic-management/integrations/api-calls/',
            lazy: IntegrationList,
        },
        {
            path: '/logistic-management/integrations/api-calls/view/:viewId',
            lazy: IntegrationList,
        },
    ];
};
